import { dew as _DefaultVideoTileDew } from "../videotile/DefaultVideoTile";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const DefaultVideoTile_1 = __importDefault(_DefaultVideoTileDew());
  class DefaultVideoTileFactory {
    makeTile(tileId, localTile, tileController, devicePixelRatioMonitor) {
      return new DefaultVideoTile_1.default(tileId, localTile, tileController, devicePixelRatioMonitor);
    }
  }
  exports.default = DefaultVideoTileFactory;
  //# sourceMappingURL=DefaultVideoTileFactory.js.map
  return exports;
}